module.exports = __webpack_public_path__ + "media/images/map_icons/Music-f465565fdbbde13a77d12a7eaffce334.svg";